import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import React, { useState } from 'react';
import MultilanguageDrawer from '../ML/MLDrawer';
import AppInformationDrawer from '../AppInformation/AppInformationDrawer';
import { SvgMultilanguage } from '../ProfileMenus';
import { SvgChangeEditType } from '../SvgComponents/SvgChangeEditType';
import { Option } from './Option';
import { OptionGroup } from './OptionGroup';
import Settings from '@material-ui/icons/Settings';

export type SettingsMenuProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	setEditType: (editType: any) => void;
};

export const SettingsMenu = (props: SettingsMenuProps) => {
	const { open, setOpen, setEditType } = { ...props };
	const [appInfoOpen, setAppInfoOpen] = useState(false);

	const handleEditorChange = () => {
		localStorage.removeItem('editType');
		setEditType('select');
	};
	return (
		<OptionGroup title="Settings">
			<MultilanguageDrawer open={open} setOpen={setOpen} />
			<AppInformationDrawer open={appInfoOpen} setOpen={setAppInfoOpen} />
			<Option clickable icon={SvgMultilanguage} label="Multilingual" onClick={() => setOpen(true)} />
			<Option
				clickable
				icon={ExitToAppIcon}
				label="Go to Dashboard"
				onClick={() => window.open('dashboard', '_blank').focus()}
			/>
			<Option clickable icon={SvgChangeEditType} label="Change editor" onClick={handleEditorChange} />
			<Option clickable icon={Settings} label="App Information" onClick={() => setAppInfoOpen(true)} />
		</OptionGroup>
	);
};
